import TinyGesture from '../vendors/tinygesture-1.1.4/TinyGesture';

export default class HorizontalList {
	
	constructor(target, options) 
	{
		if(! target) {
			this.disableControls();
			return;
		}
		
		const defaults = {
			list: '.hl-contents',
			items: '.hl-item',
			buttonNext: '.hl-control-next',
			buttonPrev: '.hl-control-prev',
			buttonDisabledClassName: 'hl-control-disabled',
			prop: 'marginLeft'
		};
		
		this.options = Object.assign(defaults, options);
		this.target = target;
		this.items = this.target.querySelectorAll(this.options.items);
		this.element = this.target.querySelector(this.options.list);
		
		if(! this.element) {
			this.disableControls();
			return;
		}
		
		this.buttons = {
			prev: this.target.querySelector(this.options.buttonPrev),
			next: this.target.querySelector(this.options.buttonNext),
		};
		
		if(! (this.buttons.prev && this.buttons.next) ) {
			this.disableControls();
			return;
		}
		
		if(this.items.length < 2) {
			this.disableControls();
			return;
		}
		
		this.disableControls('prev');
		this.initialize();
	}
	
	
	
	initialize() 
	{
		const _this = this;
		
		this.startMargin = this.getValue();
		
		_this.setSizeInfo();
		
		window.addEventListener('resize',() => {
			_this.setSizeInfo();
		});
		
		this.gesture = new TinyGesture(_this.element);
		this.gesture.on('swiperight', event => {
			//alert('gesture');
			//if( gesture.swipingDirection === 'horizontal') {
			_this.update(1);//_this.gesture.touchMoveX);
			//}
		});
		this.gesture.on('swipeleft', event => {
			//if( gesture.swipingDirection === 'horizontal') {
			_this.update(-1);//_this.gesture.touchMoveX);
			//}
		});
		
		this.gesture.on('panend', event => {
			_this.startMargin = _this.getValue();
		});
		
		this.buttons.prev.addEventListener('click', event => {
			_this.update(1);
			_this.startMargin = _this.getValue();
		});
		
		this.buttons.next.addEventListener('click', event => {
			_this.update(-1);
			_this.startMargin = _this.getValue();
		});
	}
	
	
	
	setSizeInfo() 
	{
		this.itemWidth = this.items[0].offsetWidth + parseInt(this.items[0].style.marginLeft || 0, 10) + parseInt(this.items[0].style.marginRight || 0, 10);
		
		const innerWidth = this.itemWidth  * this.items.length;
		const outerWidth = this.element.offsetWidth;
		const margin = this.getValue();
		
		if( innerWidth < outerWidth ) {
			// all the items are visible on screen
			this.elementOffsetX = this.startMargin;
			this.keepInBounds(margin);
			return;
		}

		this.elementOffsetX = (this.target.offsetWidth - this.startMargin) - (this.itemWidth  * this.items.length);	
		this.keepInBounds(margin);
	}
	
	
	
	update(delta) 
	{
		const deltaPx = delta * this.itemWidth;
		const margin = this.keepInBounds(this.startMargin + deltaPx);
		this.setValue(margin);
	}
	
	
	
	keepInBounds(margin) 
	{
		if( margin <= this.elementOffsetX ) {
			this.disableControls('next');
			return this.elementOffsetX;
		}
		this.enableControls('next');
		
		if( margin >= 0 ) {
			this.disableControls('prev');
			return 0;
		}
		this.enableControls('prev');
		
		return margin;
	}
	
	
	setValue(val) 
	{
		this.element.style.marginLeft = `${val}px`;
	}
	
	
	getValue() 
	{
		return parseInt(this.element.style.marginLeft, 10) || 0;
	}
	
	
	enableControls(w = null) 
	{
		if( this.buttons.prev && (! w || w === 'prev') ) {
			this.setControlState(this.buttons.prev, true);
		}
		
		if( this.buttons.next && (! w || w === 'next') ) {
			this.setControlState(this.buttons.next, true);
		}
	}
	
	disableControls(w = null) {
		if( this.buttons.prev && (! w || w === 'prev') ) {
			this.setControlState(this.buttons.prev, false);
		}
		
		if( this.buttons.next && (! w || w === 'next') ) {
			this.setControlState(this.buttons.next, false);
		}
	}
	
	
	setControlState(c, enabled) 
	{
		if( enabled ) {
			return c.classList.remove(this.options.buttonDisabledClassName);
		}
		return c.classList.add(this.options.buttonDisabledClassName)
	}
}

